import { Box } from "@wix/design-system";
import { Loader } from "@wix/design-system";

export const MiddleScreenLoader = () => {
  return (
    <Box width={"100%"} height={"100vh"} align="center" verticalAlign="middle">
      <Loader size="medium" />
    </Box>
  );
};
